import React, { SyntheticEvent, useEffect, useState } from 'react';

import { calendar, down, globe, sortA, trendUp } from '@/assets/icons';
import { classNames } from '@/helpers/classNames';
import { Capacitor } from '@capacitor/core';
import { SvgIcon } from '@material-ui/core';

import { AsaphDropdownMenu } from '../shared/AsaphDropdownMenu';
import { RoundedButton } from '../shared/RoundedButton';
import styles from './SortBar.module.scss';

export enum SortEnum {
	ALPHANUMERIC = 'ALPHANUMERIC',
	TOP_RATED_TEAM = 'TOP_RATED_TEAM',
	TOP_RATED_GLOBAL = 'TOP_RATED_GLOBAL',
	LAST_PLAYED = 'LAST_PLAYED',
}

export type SortBarProps = {
	className?: string;
	defaultSort?: SortEnum;
	onChange: (sort: SortEnum) => void;
};

const isCapacitor = Capacitor.isNativePlatform();

export const SortBar: React.FC<SortBarProps> = ({
	className,
	defaultSort,
	onChange,
}) => {
	const [anchorEl, setAnchorEl] = useState<Element | null>(null);
	const [activeSort, setActiveSort] = useState<SortEnum>(
		defaultSort || SortEnum.TOP_RATED_TEAM,
	);
	useEffect(() => {
		onChange(activeSort);
	}, [activeSort, onChange]);

	const handleOpen = (e: SyntheticEvent) => {
		setAnchorEl(e.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleSelect = (filter: SortEnum) => {
		setActiveSort(filter);
		handleClose();
	};

	const open = !!anchorEl;
	const sortComonents = getSortComponents(activeSort);

	const chevron = <SvgIcon component={down} style={{ fontSize: 14 }} />;

	return (
		<div className={classNames([styles['root'], className])}>
			<div className={styles['type']}>
				<SvgIcon
					viewBox={sortComonents.viewBox}
					className={styles['icon']}
					component={sortComonents.icon}
				/>
				<div className={styles['label']}>{sortComonents.label}</div>
			</div>
			<RoundedButton
				className={styles['view-button']}
				size="md"
				trailingComponent={chevron}
				onClick={handleOpen}
			>
				Sort By
			</RoundedButton>
			<AsaphDropdownMenu
				className={styles['dropdown-menu']}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				selectable
				items={[
					{
						label: 'Top rated',
						selected: activeSort === SortEnum.TOP_RATED_TEAM,
						onClick: () => {
							handleSelect(SortEnum.TOP_RATED_TEAM);
						},
					},
					// {
					// 	label: 'Top rated (global)',
					// 	selected: activeSort === SortEnum.TOP_RATED_GLOBAL,
					// 	onClick: () => {
					// 		handleSelect(SortEnum.TOP_RATED_GLOBAL);
					// 	},
					// },
					{
						label: 'Last played',
						selected: activeSort === SortEnum.LAST_PLAYED,
						onClick: () => {
							handleSelect(SortEnum.LAST_PLAYED);
						},
					},
					{
						label: 'A to Z',
						selected: activeSort === SortEnum.ALPHANUMERIC,
						onClick: () => {
							handleSelect(SortEnum.ALPHANUMERIC);
						},
					},
				]}
			/>
		</div>
	);
};

type SortComponents = {
	label: string;
	icon: React.FunctionComponent;
	viewBox?: string;
};

function getSortComponents(sort: SortEnum): SortComponents {
	switch (sort) {
		case SortEnum.TOP_RATED_GLOBAL:
			return {
				label: 'Top rated (global)',
				icon: globe,
			};
		case SortEnum.TOP_RATED_TEAM:
			return {
				label: 'Top rated',
				icon: trendUp,
			};
		case SortEnum.LAST_PLAYED:
			return {
				label: 'Last played',
				icon: calendar,
			};
		default:
			return {
				label: 'A to Z',
				icon: sortA,
				viewBox: '0 0 18 12',
			};
	}
}
